import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import { authClient, betterAuthErrorText } from "lib/auth/authClient";
import { VerifyTotpVariables } from "./useVerifyTotp";

type VerifyBackupCodeData = { token?: string };

// Verifies a one-time backup code — the sign-in recovery path when the user can't produce a TOTP
// code (lost authenticator). The code is consumed server-side and a full session is established.
export function useVerifyBackupCode(
  options?: UseMutationOptions<VerifyBackupCodeData, unknown, VerifyTotpVariables, unknown>,
) {
  return useMutation({
    mutationFn: async ({
      code,
      trustDevice,
    }: VerifyTotpVariables): Promise<VerifyBackupCodeData> => {
      const { data, error } = await authClient.twoFactor.verifyBackupCode({ code, trustDevice });
      if (error) {
        throw new Error(betterAuthErrorText(error.message, "Invalid backup code"));
      }
      return data;
    },
    ...options,
  });
}
